import React from 'react'
import classnames from 'classnames'
import { Columns, Column } from 'react-flex-columns'
import { Menu, MenuList, MenuButton, MenuLink } from '@reach/menu-button'
import '@reach/menu-button/styles.css'
import { Link } from 'gatsby'
import Centered from 'shared/ui/Centered'
import Icon from 'shared/ui/Icon'
import Logo from 'shared/ui/Logo'
import './PrimaryHeader.scss'

function PrimaryHeader({ darkHeader = false }) {
  return (
    <header className={classnames(`primary-header`, { small: darkHeader })}>
      <Centered>
        <Columns split middle>
          <Column>
            <Link to="/" className="react-training-logo-link">
              <Logo size={darkHeader ? 5 : 10} light={darkHeader} withIcon />
            </Link>
          </Column>
          <Column>
            <nav className="primary-mobile-nav">
              <Menu>
                <MenuButton className="icon-text">
                  <span>Menu</span>
                  <Icon name="menu" size={1.3} />
                </MenuButton>
                <MenuList className="primary-mobile-nav-menu">
                  <MenuLink as={Link} to="/">
                    Home
                  </MenuLink>
                  <MenuLink as={Link} to="/corporate-training">
                    Corporate Training
                  </MenuLink>
                  <MenuLink as={Link} to="/public-workshops">
                    Public Workshops
                  </MenuLink>
                  <MenuLink as={Link} to="/learn">
                    Online Courses
                  </MenuLink>
                  <MenuLink as={Link} to="/blog">
                    Blog
                  </MenuLink>
                  <MenuLink as={Link} to="/contact">
                    Contact
                  </MenuLink>
                </MenuList>
              </Menu>
            </nav>

            <nav className="primary-nav">
              <Link activeClassName="active" to="/corporate-training">
                Corporate Training
              </Link>
              <Link activeClassName="active" to="/public-workshops">
                Public Workshops
              </Link>
              <Link activeClassName="active" to="/learn">
                Online Courses
              </Link>
              <Link activeClassName="active" to="/blog">
                Blog
              </Link>
              <Link activeClassName="active" to="/contact">
                Contact
              </Link>
            </nav>
          </Column>
        </Columns>
      </Centered>
    </header>
  )
}

export default PrimaryHeader
